import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText
} from "reactstrap";
import { Circle } from "react-feather"; // Make sure to import the Circle component
import { PRIMARY_TEXT_COLOR } from "../../color";

const BulletList = ({ para }) => {
  return (
    <div>
      <strong className="pr-2">
        <Circle size={6} fill={PRIMARY_TEXT_COLOR} />
      </strong>
      {para}
    </div>
  );
};

const PrivacyPolicy = () => {
  return (
    <div className="mt-3"  style={{ backgroundColor: "rgb(201 201 213 / 3%)" ,color:PRIMARY_TEXT_COLOR}}>
      <div className="my-5">
        <Row>
          <Col md={{ size: 8, offset: 2 }}>
            <CardBody>
              <div className="py-4 px-2 d-flex justify-content-center">
                <h6 className="headingMainStyle">
                  <span>Privacy Policy</span>
                </h6>
              </div>
              <CardText style={{color:PRIMARY_TEXT_COLOR}}>
                <p style={{color:PRIMARY_TEXT_COLOR}} className="fst-italic mb-4">Dated : 17th January 2025</p>
                
                <p style={{color:PRIMARY_TEXT_COLOR}}>Welcome to beteljobs! We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and safeguard your information when you use our website and services.</p>
                
                <div className="mt-4 pl-3">
                  <h6 className="fw-bold">1. Information We Collect</h6>
                  <p style={{color:PRIMARY_TEXT_COLOR}}>We collect the following types of information to provide and improve our services:</p>
                  
                  <div className="ms-3">
                    <h6 className="fw-bold">a. Personal Information</h6>
                    <ul className="list-unstyled pl-3">
                      <li><BulletList para="Name, email address, phone number, and mailing address." /></li>
                      <li><BulletList para="Professional information such as qualifications, certifications, work experience, and references." /></li>
                      <li><BulletList para="Payment details for subscription-based services." /></li>
                    </ul>

                    <h6 className="fw-bold mt-3">b. Non-Personal Information</h6>
                    <ul className="list-unstyled pl-3">
                      <li><BulletList para="Browser type, operating system, and device information." /></li>
                    </ul>

                    <h6 className="fw-bold mt-3">c. Job Application Data</h6>
                    <ul className="list-unstyled pl-3">
                      <li><BulletList para="Resumes, cover letters, and supporting documents submitted for job applications." /></li>
                    </ul>

                    <h6 className="fw-bold mt-3">d. Third-Party Data</h6>
                    <ul className="list-unstyled pl-3">
                      <li><BulletList para="Information from LinkedIn or other platforms if linked to your account." /></li>
                    </ul>
                  </div>

                  <h6 className="fw-bold mt-4">2. How We Use Your Information</h6>
                  <p style={{color:PRIMARY_TEXT_COLOR}}>We use the information collected for:</p>
                  <ul className="list-unstyled pl-3">
                    <li><BulletList para="Facilitating job searches and applications." /></li>
                    <li><BulletList para="Matching candidates with suitable employers." /></li>
                    <li><BulletList para="Improving website functionality and user experience." /></li>
                    <li><BulletList para="Sending account updates, job alerts." /></li>
                    <li><BulletList para="Processing payments and subscriptions." /></li>
                  </ul>

                  <h6 className="fw-bold mt-4">3. Sharing Your Information</h6>
                  <p style={{color:PRIMARY_TEXT_COLOR}}> We may share your information with:</p>
                  <ul className="list-unstyled pl-3">
                    <li><BulletList para="Employers and Recruiters: To facilitate job applications." /></li>
                    <li><BulletList para="Service Providers: For website hosting, payment processing, and email services." /></li>
                    <li><BulletList para="Legal Authorities: When required by law or to protect our legal rights." /></li>
                    <li><BulletList para="Third-Party Integrations: With your explicit consent for connected services (e.g., LinkedIn)." /></li>
                  </ul>
                  <p style={{color:PRIMARY_TEXT_COLOR}}> We do not sell your personal data to third parties.</p>

                  <h6 className="fw-bold mt-4">4. Data Security</h6>
                  <p style={{color:PRIMARY_TEXT_COLOR}}> We implement industry-standard security measures to protect your data, including encryption and secure servers. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>

                  <h6 className="fw-bold mt-4">5. Your Rights</h6>
                  <p style={{color:PRIMARY_TEXT_COLOR}}> Depending on your location, you may have the following rights:</p>
                  <ul className="list-unstyled pl-3">
                    <li><BulletList para="Access and Correction: View and update your personal information." /></li>
                    <li><BulletList para="Data Deletion: Request deletion of your data (subject to legal obligations)." /></li>
                    <li><BulletList para="Withdraw Consent: Opt-out of marketing communications." /></li>
                    <li><BulletList para="Data Portability: Receive a copy of your data in a structured format." /></li>
                    <li><BulletList para="To exercise your rights, please contact us at support@beteljobs.com" /></li>
                  </ul>

                  <h6 className="fw-bold mt-4">6. Third-Party Links</h6>
                  <p style={{color:PRIMARY_TEXT_COLOR}}> Our website may contain links to third-party websites. We are not responsible for their privacy practices or content. Please review their privacy policies before sharing your data.</p>

                  <h6 className="fw-bold mt-4">7. Changes to This Policy</h6>
                  <p style={{color:PRIMARY_TEXT_COLOR}}> We may update this Privacy Policy from time to time. Changes will be posted on this page, and significant updates will be notified via email or on the website.</p>

                  <h6 className="fw-bold mt-4">8. Contact Us</h6>
                  <p style={{color:PRIMARY_TEXT_COLOR}}> If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
                  <ul className="list-unstyled pl-3">
                    <li><BulletList para="Email: support@beteljobs.com" /></li>
                  </ul>
                </div>

                <p style={{color:PRIMARY_TEXT_COLOR}} className="mt-4">By using beteljobs.com, you agree to this Privacy Policy. Thank you for trusting us with your information.</p>
              </CardText>
            </CardBody>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
